import React from "react";
import { Link } from "react-router-dom";

const CRAFTED_EXPERIENCES = [
  {
    id: 1,
    title: "Sunrise Hot Air Balloon Experience",
    location: "Cairns, Australia",
    price: "AUD 299",
    slug: "sunrise-hot-air-balloon-1",
    img: "/images/crafted/sunrise-balloon.jpg",
    isTall: true,
  },
  {
    id: 2,
    title: "Indigenous Culture & Storytelling",
    location: "Uluru, Northern Territory",
    price: "AUD 189",
    slug: "indigenous-culture-storytelling-2",
    img: "/images/crafted/indigenous-culture.jpg",
    isTall: true,
  },
  {
    id: 3,
    title: "Private Yacht Escape",
    location: "Whitsundays, Queensland",
    price: "AUD 499",
    slug: "private-yacht-escape-3",
    img: "/images/crafted/private-yacht.jpg",
    isTall: false,
  },
  {
    id: 4,
    title: "Outback Dining Under the Stars",
    location: "Alice Springs, NT",
    price: "AUD 499",
    slug: "outback-dining-under-stars-4",
    img: "/images/crafted/outback-dining.jpg",
    isTall: false,
  },
  {
    id: 5,
    title: "Wildlife Encounter with Locals",
    location: "Kangaroo Island, SA",
    price: "AUD 219",
    slug: "wildlife-encounter-locals-5",
    img: "/images/crafted/wildlife-kangaroo.jpg",
    isTall: false,
  },
];

function CraftedV1() {
  return (
    <section className="v1-crafted-section">
      <div className="v1-crafted-inner">
        <div className="v1-crafted-grid">
          {/* Item 1: Row 1, Column 1 - Header / Title Block */}
          <div className="v1-crafted-header-block">
            <span className="v1-crafted-tag">
              EXCLUSIVE · AUTHENTIC · MEANINGFUL
            </span>
            <h2 className="v1-crafted-title">
              Weyfarin
              <br />
              Crafted
              <br />
              Experiences
            </h2>
            <p className="v1-crafted-desc">
              Our signature collection of handpicked experiences, designed with care,
              local insight and a passion for authentic travel.
            </p>

            <Link to="/experiences" className="v1-crafted-cta-btn">
              <span>Explore Crafted Experiences</span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </Link>
          </div>

          {/* Items 2 & 3: Row 1, Columns 2 & 3 (Tall Cards) */}
          {/* Items 4, 5 & 6: Row 2, Columns 1, 2 & 3 (Standard Cards) */}
          {CRAFTED_EXPERIENCES.map((item) => (
            <Link
              key={item.id}
              to={`/experience/${item.slug}`}
              className={`v1-crafted-card ${
                item.isTall ? "v1-crafted-card-tall" : ""
              }`}
            >
              <img
                src={item.img}
                alt={item.title}
                className="v1-crafted-img"
                loading="lazy"
              />
              <div className="v1-crafted-overlay"></div>
              <span className="v1-crafted-badge-pill">WEYFARIN CRAFTED</span>

              <div className="v1-crafted-card-content">
                <h3 className="v1-crafted-card-title">{item.title}</h3>
                <p className="v1-crafted-card-location">{item.location}</p>
                <p className="v1-crafted-card-price">
                  From <span className="v1-crafted-price-bold">{item.price}</span>
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CraftedV1;

